import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "dialog-detail flex align-items-center justify-content-center mt-s2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-s1" }, "/", -1)
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "dialog-footer dialog-footer-two-btn" }

import Spinner from '@/components/Spinner.vue';
import { useI18n } from 'vue-i18n';
import LpAmountFormat from '@/components/LpAmountFormat.vue';
import { printUSD } from '@/utils/format';


export default /*#__PURE__*/_defineComponent({
  __name: 'StakeConfirmation',
  props: {
    action: null,
    stake: null,
    stakeUsd: null,
    cancel: null,
    confirm: null,
    inProgress: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.action === 'stake'
        ? _unref(t)(`farming.${__props.action}ConfirmDialog.yourStake`)
        : _unref(t)(`farming.${__props.action}ConfirmDialog.yourUnstake`)), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LpAmountFormat, { "lp-amount": __props.stake }, null, 8, ["lp-amount"]),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(printUSD)(__props.stakeUsd)) + " ", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _unref(t)('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.cancel()))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)(`farming.${__props.action}ConfirmDialog.confirmBtn`),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.confirm())),
        disabled: __props.inProgress
      }, {
        default: _withCtx(() => [
          (__props.inProgress)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                color: "white",
                size: "24",
                class: "mr-s2"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)(`farming.${__props.action}ConfirmDialog.confirmBtn`)), 1)
        ]),
        _: 1
      }, 8, ["label", "disabled"])
    ])
  ], 64))
}
}

})